<template>
<div class="popup" v-cloak v-if="errNoticeShow"  style="zIndex:200">
    <div class="content" id="noticeRemind">
        <div class="title">
            {{$t('language.paySystem.Notice')}}
            <div class="icon white-close dialog-close" @click="closePage()"></div>
        </div>
        <div class="pay-error-content">    
           <p>{{$t('language.paySystem.tryAgain')}}</p>
           <p v-html="$t('language.paySystem.contactPayment')"> </p>
            <div class="bind-remind-footer">
                <div class="error-button" >
                    <button style="border-radius: 5Px;minWidth:80Px;" @click="closePage()">{{$t('language.common.ok')}}</button>
                </div>
                <div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            errNoticeShow: false,
        }
    },
    methods: {
       closePage(){
         this.errNoticeShow = false;
       },

    }
}
</script>

<style>
#noticeRemind {
    width: 500Px;
    height: 215Px;
}

.pay-error-content {
    width: 100%;
    height: 140Px;
    box-sizing: border-box;
    padding: 0px 15px;
    /*no*/
    font-size: 14px;
    /*no*/
    line-height: 20Px;
}

.pay-error-content a{
    text-decoration: none;
}
.bind-remind-footer {
    height: 35Px;
}

.error-button {
    float: right;
}



</style>



// WEBPACK FOOTER //
// src/components/popup/pay_system_popups/pay_error_notice_popup.vue